// src/index.ts
var isEdgeToEdgeFromLibrary = () => true;
var isEdgeToEdgeFromProperty = () => true;
var isEdgeToEdge = () => true;
var controlEdgeToEdgeValues = (values) => {
};

export { controlEdgeToEdgeValues, isEdgeToEdge, isEdgeToEdgeFromLibrary, isEdgeToEdgeFromProperty };
//# sourceMappingURL=index.mjs.map
//# sourceMappingURL=index.mjs.map